import * as _ from 'underscore';
import { FlowBasicInfo } from '../models/FlowInfo';
import { IDataConnectionInfo } from '../models/IDataConnectionInfo';
import { IDataSourceBasicInfo } from '../models/IDataSourceInfo';
import { IDataConnection } from '../ServerApi/types/IDataConnection';
import { MapperHelper } from './MapperHelper';

export module DataConnectionMapper {

  export function map(
    serverApiDataConnections: IDataConnection[],
    dataSources: _.Dictionary<IDataSourceBasicInfo>,
    flows: _.Dictionary<FlowBasicInfo>,
  ): IDataConnectionInfo[] {
    return _.map(serverApiDataConnections, (c: IDataConnection) => {

      const connectionInfo: IDataConnectionInfo = {
        id:                        c.id,
        favorite:                  false, // Can't favorite data connections, but needs to adhere to IContentInfo interface
        contentType:               'dataconnection',
        connectionType:            c.connectionType,
        connectionTypeDisplayName: c.connectionTypeDisplayName,
        connectionDetails:         c.connectionDetails,
        connectionTypeEditable:    c.connectionTypeEditable,
        connectionOAuth:           c.connectionOAuth,
        testingConnectionAllowed:  c.testingConnectionAllowed,
        usingRemoteQueryAgent:     c.usingRemoteQueryAgent,
        updatedAt:                 MapperHelper.toDate(c.updatedAt),
        ...c.datasourceId && {
          datasource: dataSources[c.datasourceId]
        },
        ...c.flowId && {
          flow: flows[c.flowId]
        },
      };

      return connectionInfo;
    });
  }

}
